import { render, staticRenderFns } from "./setMoney.vue?vue&type=template&id=018156a4&scoped=true&"
import script from "./setMoney.vue?vue&type=script&lang=js&"
export * from "./setMoney.vue?vue&type=script&lang=js&"
import style0 from "./setMoney.vue?vue&type=style&index=0&lang=css&"
import style1 from "./setMoney.vue?vue&type=style&index=1&id=018156a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018156a4",
  null
  
)

export default component.exports